import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

export const HeaderSidebarButton = () => {
  const { isSidebarOpen, collapseSideBar, expandSideBar } =
    useHelpWidgetContext();

  const handleClick = () => {
    if (isSidebarOpen) {
      collapseSideBar();
    } else {
      expandSideBar();
    }
  };

  return (
    <TippyV2
      content={
        isSidebarOpen
          ? t("help_widget.tooltip.hide_conversations")
          : t("help_widget.tooltip.show_conversations")
      }
    >
      <button
        type="button"
        onClick={handleClick}
        className="hover:bg-secondary text-light flex h-6 w-6 items-center rounded-full p-1"
      >
        <Icon type="sw-expand-sidebar" useWithFillCurrentColor size={16} />
      </button>
    </TippyV2>
  );
};
